module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-suzanne.d4fda2ec.jpg";